var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex"},[_c('i',{staticClass:"text-gray z-20 text-30 lg:text-56 fas fa-spinner fa-spin mx-auto"})])
}]

export { render, staticRenderFns }